import { PageHeading } from "../../shared/components/heading";
import request from "../../shared/utils/request";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import { Loader } from "../../shared/components/loader";
import { LoadingButton } from "../../shared/components/loadingButton";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const GrammerBookView = () => {
  const [loading, setLoading] = useState(false);
  const [questionData, setQuestionData] = useState(null);
  const { id } = useParams();

  const formik = useFormik({
    initialValues: {
      question_id: "",
      answer: [{ left: "", right: "" }],
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const response = await request.post(
          `student/studentGrammerBookAnswer`,
          values
        );
        if (response?.data?.success) {
          toast.success(response?.data?.message, {
            autoClose: 4000,
          });
        }
        formik.setValues({
          answer: [{ left: "", right: "" }],
        });
        fetchData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }

      // API submission logic goes here
    },
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await request.get(
        `student/getGrammerBookQuestionById/${id}`
      );
      if (response?.data?.status) {
        const data = response.data.data;
        setQuestionData(data);
        formik.setValues({
          question_id: data?.id,
          answer: data?.statement?.length
            ? data.statement
            : [{ left: "", right: "" }],
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="services" className="services section my-library">
      <div className="container section-title" data-aos="fade-up">
        <PageHeading heading="My Grammar Book" />
      </div>
      <Loader isLoading={loading} />
      <div className="container">
        <div className="preview-container">
          <div className="document-header">
            <h1 className="document-title text-break">{questionData?.question}</h1>
            <p
              className="document-description text-break"
              dangerouslySetInnerHTML={{
                __html: questionData?.question_description,
              }}
            ></p>
          </div>
          <div className="pdf-preview">
            <form onSubmit={formik.handleSubmit}>
              <LoadingButton
                buttonText="Save Answer"
                customClass="create-btn  mb-3"
                iconType="bi-floppy"
              />
              {formik.values.answer.map((item, index) => (
                <div className="row mt-2 g-2" key={index}>
                  <div className="col-12 col-md-5">
                    <textarea
                      className="form-control"
                      name={`answer.${index}.left`}
                      value={item.left}
                      disabled={questionData?.isLeftDisabled}
                      onChange={formik.handleChange}
                      rows="3"
                    />
                  </div>
                  <div className="col-12 col-md-5">
                    <textarea
                      className="form-control"
                      name={`answer.${index}.right`}
                      value={formik.values.answer[index].right}
                      onChange={formik.handleChange}
                      rows="3"
                    />
                  </div>
                  <div className="col-12 col-md-2">
                    {index === formik.values.answer.length - 1 ? (
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={() =>
                          formik.setFieldValue("answer", [
                            ...formik.values.answer,
                            { left: "", right: "" },
                          ])
                        }
                      >
                        Add Row
                      </button>
                    ) : (
                      !formik.values.answer[index].left && (
                        <button
                          type="button"
                          className="btn btn-danger w-100"
                          onClick={() => {
                            const updatedStatements = [...formik.values.answer];
                            updatedStatements.splice(index, 1);
                            formik.setFieldValue("answer", updatedStatements);
                          }}
                        >
                          Remove
                        </button>
                      )
                    )}
                  </div>
                </div>
              ))}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
